import { userDisplayName } from "common-fe";

// #2194 -- resolve a Cognito sub (a Class.scribeAssignments entry, #396) to a
// display name for the Start Scoring not-assigned message. Pages
// GET /org/{orgId}/member (account-api's listOrgMembers) the same way
// scoreadmin-fe's useOrgMembers does (#2339 -- a single unpaged page can
// silently hide a member past it), but as a plain on-demand async function
// rather than a hook: this only ever needs to run once, lazily, on the rare
// press where verifyStillAssignedScribe (ScoringForm.jsx) finds the caller
// is NOT the assignee, so a scribe's ordinary session never pays for an org
// member fetch it doesn't need.
const MAX_PAGE_SIZE = 100;

export async function resolveOrgMemberName(accountApi, orgId, userId) {
  if (!accountApi || !orgId || !userId) return null;
  let cursor;
  try {
    do {
      const res = await accountApi.org.listOrganizationMembers(
        orgId,
        MAX_PAGE_SIZE,
        cursor
      );
      if (res.data?.status !== "success") return null;
      const page = Array.isArray(res.data.data?.members)
        ? res.data.data.members
        : [];
      const found = page.find((m) => m.userId === userId);
      if (found) return userDisplayName(found) || null;
      cursor = res.data.data?.nextCursor || undefined;
    } while (cursor);
  } catch {
    // Flaky venue wifi, account-api hiccup, etc. -- returning null here
    // leaves the caller with a truthy assigneeSub and a null assigneeName,
    // so ScoringForm.jsx renders scoring.startScoringNotAssignedUnknown
    // ("assigned to another scribe") rather than the "not assigned to
    // anyone" branch (that one only fires when assigneeSub itself is null,
    // i.e. no scribe is assigned at all). Either way Start Scoring's
    // rejection message isn't blocked on a lookup that can't complete.
    return null;
  }
  return null;
}

export default resolveOrgMemberName;
